/*
 *  Bootstrap Nice Select Czech (Czech Republic) Translation
 *  Author: Kevin Gostomski <kevingostomski2001@gmail.com> 
*/

const localisation = {
    locales: []
}

localisation.locales['cs-CZ'] = localisation.locales['cs'] = {
    formatSearch() {
        return "Hledání...";
    },
    formatHelpForTagging() {
        return "Chcete-li vytvořit vlastní tagy, zaměřte se na vstupní pole a poté stiskněte 'Enter' nebo ',' nebo 'Mezerník' pro přidání do seznamu";
    }
}

export default localisation;